import { render } from "./Comment.vue?vue&type=template&id=369befc2&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=369befc2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-369befc2"

export default script